<app-dialog [dialogWithInput]="dialog">
    <app-lov-value-update (entitySaved)="onEntitySaved($event)"
                          [inDialog]="true"
                          [lovListName]="dialog.input.lovListName"></app-lov-value-update>
</app-dialog>
